import * as Yup from 'yup';

export const sectorValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome do setor é obrigatório')
    .min(2, 'Nome deve ter no mínimo 2 caracteres')
    .max(255, 'Nome deve ter no máximo 255 caracteres'),
  description: Yup.string()
    .max(1000, 'Descrição deve ter no máximo 1000 caracteres')
    .optional(),
});